<template>
  <div
    ref="advance_filter"
    id="advance_filter"
    class="modal modal-right fade modal-more-filters"
    tabindex="-1"
    role="dialog"
    aria-labelledby="advance_filter"
  >
    <div class="modal-dialog" role="document" style="width: 360px">
      <div class="modal-content" ref="section">
        <div class="modal-header bg-dark">
          <h6 class="modal-title">{{ $t("More Filters") }}</h6>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body p-0 pb-5 px-0">
          <!-- order status -->
          <div
            class="card card-collapsed border-0 shadow-none mb-0"
          >
            <div class="card-header header-elements-inline border-0 shadow-none p-0">
              <div
                @click="toggleOption('status')"
                name="status"
                aria-expanded="false"
                class="font-weight-semibold cursor-pointer collapsed w-100 d-flex justify-content-between py-2 px-3"
                data-toggle="collapse"
                data-target="#collapse-status"
              >
                <div>{{ $t("Order Status") }}</div>
                <div class="header-elements">
                  <div class="list-icons">
                    <a
                      :class="['list-icons-item', {'rotate-180': options.order_status}]"
                      data-action="collapse"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="collapse ui-filter-list card-body  px-4"
              id="collapse-status"
            >
              <div class="filter-option">
                <div
                  class="form-group"
                  :class="{'mb-0': !$parent.statusList.length}"
                >
                  <div
                    class="form-check"
                    v-for="Status in $parent.statusList"
                    :key="Status.id"
                  >
                    <label class="form-check-label">
                      <div class="uniform-checker">
                        <span :class="{'checked' : dataFilter.order_status.includes(Status.id)}">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :value="Status.id"
                            :id="'status-'+Status.id"
                            v-model="dataFilter.order_status"
                          >
                        </span>
                      </div>
                      <span>{{ $t(Status.name) }}</span>
                    </label>
                  </div>
                </div>
                <div class="clear">
                  <a
                    href="javascript:void(0)"
                    class="text-secondary"
                    @click="clearFilter('status')"
                  >{{ $t("Clear") }}</a>
                </div>
              </div>
            </div>
          </div>

          <!-- payment method -->
          <div class="card card-collapsed border-0 shadow-none mb-0">
            <div class="card-header header-elements-inline border-0 shadow-none p-0">
              <div
                @click="toggleOption('paymentMethod')"
                name="payment_method"
                aria-expanded="false"
                class="font-weight-semibold cursor-pointer collapsed w-100 d-flex justify-content-between py-2 px-3"
                data-toggle="collapse"
                data-target="#collapse-payment-method"
              >
                <div>{{ $t("Payment Method") }}</div>
                <div class="header-elements">
                  <div class="list-icons">
                    <a
                      :class="[
                        'list-icons-item',
                        { 'rotate-180': options.payment_method },
                      ]"
                      data-action="collapse"
                    ></a>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="collapse ui-filter-list card-body px-4"
              id="collapse-payment-method"
            >
              <div class="filter-option">
                <div
                  class="form-group"
                  :class="{ 'mb-0': !paymentMethodList.length }"
                >
                  <div
                    class="form-check"
                    v-for="paymentMethod in paymentMethodList"
                    :key="paymentMethod.id"
                  >
                    <!-- <label class="form-check-label">
                      <div class="uniform-checker">
                        <span
                          :class="[
                            paymentMethodList.includes(paymentMethod.id)
                              ? 'checked'
                              : '',
                          ]"
                        >
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :value="paymentMethod.id"
                            :id="'paymentMethod-' + paymentMethod.id"
                            v-model="dataFilter.payment_method"
                            @change="filterChange()"
                          />
                        </span>
                      </div>
                      {{ $t(paymentMethod.name) }}
                    </label> -->
                    <label class="form-check-label">
                      <div class="uniform-choice">
                        <span :class="[(dataFilter.payment_method === paymentMethod.id ? 'checked' : '')]">
                          <input
                            type="radio"
                            name="adv_payment_method_filter"
                            :id="paymentMethod.name"
                            :value="paymentMethod.id"
                            v-model="dataFilter.payment_method"
                            @click="disabledStatusIdUncheck('payment_method')"
                          >
                        </span>
                      </div>
                      <span>{{ $t(paymentMethod.name) }}</span>
                    </label>
                  </div>
                </div>
                <div class="clear">
                  <a
                    href="javascript:void(0)"
                    class="text-secondary"
                    @click="clearFilter('paymentMethod')"
                    >{{ $t("Clear") }}</a
                  >
                </div>
              </div>
            </div>
          </div>

          <!-- payment status -->
          <div class="card card-collapsed border-0 shadow-none mb-0">
            <div class="card-header header-elements-inline border-0 shadow-none p-0">
              <div
                @click="toggleOption('paymentStatus')"
                name="payment_status"
                aria-expanded="false"
                class="font-weight-semibold cursor-pointer collapsed w-100 d-flex justify-content-between py-2 px-3"
                data-toggle="collapse"
                data-target="#collapse-payment-status"
              >
                <div>{{ $t("Payment Status") }}</div>
                <div class="header-elements">
                  <div class="list-icons">
                    <a
                      :class="[
                        'list-icons-item',
                        { 'rotate-180': options.payment_status },
                      ]"
                      data-action="collapse"
                    ></a>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="collapse ui-filter-list card-body px-4"
              id="collapse-payment-status"
            >
              <div class="filter-option">
                <div
                  class="form-group"
                  :class="{ 'mb-0': !paymentStatusList.length }"
                >
                  <div
                    class="form-check"
                    v-for="payment in paymentStatusList"
                    :key="payment.id"
                  >
                    <!-- <label class="form-check-label">
                      <div class="uniform-checker">
                        <span
                          :class="[
                            paymentStatusList.includes(payment.id)
                              ? 'checked'
                              : '',
                          ]"
                        >
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :value="payment.id"
                            :id="'pay-' + payment.id"
                            v-model="dataFilter.payment_status"
                            @change="filterChange()"
                          />
                        </span>
                      </div>
                      {{ $t(payment.name) }}
                    </label> -->
                    <label class="form-check-label">
                      <div class="uniform-choice">
                        <span :class="[(dataFilter.payment_status === payment.id ? 'checked' : '')]">
                          <input
                            type="radio"
                            name="adv_payment_status_filter"
                            :id="payment.name"
                            :value="payment.id"
                            v-model="dataFilter.payment_status"
                            @click="disabledStatusIdUncheck('payment_status')"
                          >
                        </span>
                      </div>
                      <span>{{ $t(payment.name) }}</span>
                    </label>
                  </div>
                </div>
                <div class="clear">
                  <a
                    href="javascript:void(0)"
                    class="text-secondary"
                    @click="clearFilter('paymentStatus')"
                    >{{ $t("Clear") }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="modal-footer fixed-bottom bg-light border-top d-flex justify-content-between py-2 px-3"
        >
          <button type="button" class="btn btn-light" @click="clearFilter('all')">
            {{ $t("Clear all filters") }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="doneFilter()"
            data-dismiss="modal"
          >
            {{ $t("Done") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "advance_filter",
  components: {},
  data() {
    return {
      options: {
        payment_method: false,
        payment_status: false,
        status: false,
      },
      dataFilter: initialFilter(),
      statusList: [
        {
          id: "pending",
          icon: '<i class="fa-solid fa-clock"></i>',
          name: "_Shipment.Pending",
        },
        {
          id: "processing",
          icon: '<i class="fas fa-sync-alt"></i>',
          name: "Processing",
        },
        {
          id: "completed",
          icon: '<i class="fas fa-check-circle"></i>',
          name: "Completed",
        },
        {
          id: "returned",
          icon: '<i class="fa-solid fa-arrow-rotate-left"></i>',
          name: "_Order.Returned",
        },
        {
          id: "canceled",
          icon: '<i class="fas fa-times-square"></i>',
          name: "Cancel",
        },
      ],
      paymentStatusList: [
        {
          id: 'pending',
          name: this.$t('_Payment.Pending'),
        },
        {
          id: 'partial',
          name: this.$t('Partial Paid'),
        },
        {
          id: 'paid',
          name: this.$t('Paid'),
        },
        {
          id: 'confirmed',
          name: this.$t('Confirmed'),
        },
      ],
      paymentMethodList: [
        {
          "id": 1,
          "name": "Bank Transfer"
        },
        {
          "id": 2,
          "name": "COD"
        },
        {
          "id": 3,
          "name": "Cash"
        },
        {
          "id": 5,
          "name": "ATM"
        }
      ],
    };
  },
  async mounted() {
    this.dataFilter.order_status = this.$parent.paramsQuery.order_status;
  },
  computed: {},
  methods: {
    toggleOption(key) {
      if (key == "paymentMethod") {
        this.options.payment_method
          ? (this.options.payment_method = false)
          : (this.options.payment_method = true);
      } else if (key == "paymentStatus") {
        this.options.payment_status
          ? (this.options.payment_status = false)
          : (this.options.payment_status = true);
      } else if (key == "status") {
        this.options.status
          ? (this.options.status = false)
          : (this.options.status = true);
      }
    },
    clearFilter(key) {
      if (key == "all") {
        this.dataFilter = initialFilter();
      } else if (key == "paymentMethod") {
        this.dataFilter.payment_method = [];
      } else if (key == "paymentStatus") {
        this.dataFilter.payment_status = [];
      } else if (key == "status") {
        this.dataFilter.order_status = [];
      }
    },
    filterChange() {},
    doneFilter() {
      this.$parent.countFilter =
        (this.dataFilter.payment_method && this.dataFilter.payment_method.length == undefined ? 1 : 0) +
        (this.dataFilter.payment_status && typeof this.dataFilter.payment_status == "string" ? 1 : 0) +
        (this.dataFilter.order_status.length ? 1 : 0);
      this.$parent.filterinfo(this.dataFilter);
    },
    disabledStatusIdUncheck(choose) {
      let self = this;
      setTimeout(() => {
        if(choose == 'payment_method') {}
        else if(choose == 'payment_status') {}
      }, 100);
    },
  },
  watch: {},
};

function initialFilter() {
  return {
    payment_method: null,
    payment_status: null,
    order_status: [],
  };
}
</script>



// WEBPACK FOOTER //
// src/components/tenancy/admin/report/finance/AdvanceFilterByProvince.vue